import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
//import Flatpickr from "react-flatpickr";
//import "flatpickr/dist/themes/material_blue.css"; // nice theme
import { useParams } from 'react-router-dom';
import { useRef } from "react";

export default function UpdateCollegeLevelEvents() {

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [collegeEventData, setCollegeEventData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);
  const [selectedAdmissionYearID, setSelectedAdmissionYearID] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [selectedSemesterID, setSelectedSemesterID] = useState(null);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedSchemeID, setSelectedSchemeID] = useState(null);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedStatusID, setSelectedStatusID] = useState(null);
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [selectedCollegeID, setSelectedCollegeID] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedCollegeEvent, setSelectedCollegeEvent] = useState(null);
  const [selectedCollegeEventId, setSelectedCollegeEventId] = useState(null);
  const [allColleges, setAllColleges] = useState([]);
  const [collegeEvents, setCollegeEvents] = useState([]);
  const [collegeEventsData, setCollegeEventsData] = useState(null);

  const isEditInitialized = useRef(false);
  const { http } = Api();
  const navigate = useNavigate();


  let { id, semid } = useParams();
  const decodedID = atob(id);

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }

  const schemeOptions = [
    { value: 1, label: 'MGU-UGP' },
    { value: 2, label: 'BBA' },
    { value: 3, label: 'BCA' },
    { value: 4, label: 'B.Voc' }
  ];

  useEffect(() => {
    const getCollegeEvents = async () => {
      http.get('/Admin/getEventTimeExtension', {
        params: {
          pk_id: decodedID
        }
      })
        .then((response) => {
          setCollegeEventsData(response.data.eventdata[0]);
        }).catch((error) => {
          if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/admin/");
            }, 5000);
          }
          else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
            toast.error(error.response.data.message);
          }
          else {
            toast.error("Something went wrong");
          }
        })
    };
    getCollegeEvents();
  }, []);

  const collegeEventOptions = Array.isArray(collegeEvents)
    ? collegeEvents.map(event => ({
      value: event.id,
      label: event.event_name
    }))
    : [];


  useEffect(() => {
    if (!collegeEventsData || !allColleges.length || !collegeEventOptions.length || !collegeEventsData.start_date ||
      !collegeEventsData.end_date) {
      return;
    }

    // Run only once (edit load)
    if (isEditInitialized.current) return;

    /* ---------- College ---------- */
    const collegeOption = allColleges
      .map(c => ({ value: c.college_id, label: c.college_name }))
      .find(opt => opt.value === collegeEventsData.college_id);

    setSelectedCollege(collegeOption);
    setSelectedCollegeID(collegeEventsData.college_id);

    /* ---------- College Event ---------- */
    if (collegeEventOptions.length) {
      const eventOption = collegeEventOptions.find(
        opt => opt.value === collegeEventsData.event_id
      );
      setSelectedCollegeEvent(eventOption);
      setSelectedCollegeEventId(collegeEventsData.event_id);
    }

    /* ---------- Admission Year ---------- */
    setSelectedAdmissionYear({
      value: collegeEventsData.admission_year,
      label: String(collegeEventsData.admission_year),
    });
    setSelectedAdmissionYearID(collegeEventsData.admission_year);

    /* ---------- Semester ---------- */
    setSelectedSemester({
      value: collegeEventsData.semester_id,
      label: `Semester ${collegeEventsData.semester_id}`,
    });
    setSelectedSemesterID(collegeEventsData.semester_id);

    /* ---------- Scheme ---------- */

    const selectedSchemeOption = schemeOptions.find(
      option => option.value === collegeEventsData.scheme_id
    );

    setSelectedScheme(selectedSchemeOption);
    
    setSelectedSchemeID(collegeEventsData.scheme_id);

    /* ---------- Status ---------- */
    setSelectedStatus({
      value: collegeEventsData.status,
      label: collegeEventsData.status,
    });
    setSelectedStatusID(collegeEventsData.status);

    /* ---------- Dates ---------- */
    setStartDateTime(collegeEventsData.start_date.replace(' ', 'T').slice(0, 16));
    setEndDateTime(collegeEventsData.end_date.replace(' ', 'T').slice(0, 16));

    // lock initialization
    isEditInitialized.current = true;

  }, [collegeEventsData, allColleges, collegeEventOptions]);


  useEffect(() => {
    const getAllColleges = async () => {
      http.get('/Admin/getAllCollegeForEvents')
        .then((response) => {
          setAllColleges(response.data);
        }).catch((error) => {
          if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/admin/");
            }, 5000);
          }
          else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
            toast.error(error.response.data.message);
          }
          else {
            toast.error("Something went wrong");
          }
        })

    };
    getAllColleges();
  }, []);

  useEffect(() => {
    const getCollegeEvents = async () => {
      http.get('/Admin/getCollegeEvents')
        .then((response) => {
          setCollegeEvents(response.data);
        }).catch((error) => {
          if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/admin/");
            }, 5000);
          }
          else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
            toast.error(error.response.data.message);
          }
          else {
            toast.error("Something went wrong");
          }
        })
    };
    getCollegeEvents();
  }, []);

  useEffect(() => {

    const fetchAllEvents = async () => {
      try {
        const response = await http.get('/Admin/getAllevent');
        setEventData(response.data);
        setCollegeEventData(response.data);
      }
      catch (error) {
        if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/admin/");
          }, 5000);
        }
        else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchAllEvents();

  }, []);  

  const handleCollegeChange = (selectedOption) => {
    setSelectedCollege(selectedOption);
    setSelectedCollegeID(selectedOption.value);
    // optional: clear error
    setErrors(prev => ({ ...prev, college: null }));
  };

  const handleCollegeEventChange = (selectedOption) => {
    setSelectedCollegeEvent(selectedOption);
    setSelectedCollegeEventId(selectedOption.value);
    setErrors(prev => ({ ...prev, college_event: null }));
  };


  const handleEventChange = (selectedOption) => {
    setSelectedEvent(selectedOption);
    setSelectedEventId(selectedOption.value);
  };

  const handleAdmissionYearChange = (selectedOption) => {
    setSelectedAdmissionYear(selectedOption);
    setSelectedAdmissionYearID(selectedOption.value);
    setErrors(prev => ({ ...prev, admissionYear: null }));
  }

  const handleSemesterChange = (selectedOption) => {
    setSelectedSemester(selectedOption);
    setSelectedSemesterID(selectedOption.value);
    setErrors(prev => ({ ...prev, semester_id: null }));
  }
  const handleShemeChange = (selectedOption) => {
    setSelectedScheme(selectedOption);
    setSelectedSchemeID(selectedOption.value);
    setErrors(prev => ({ ...prev, scheme_id: null }));
  }
  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setSelectedStatusID(selectedOption.value);
    setErrors(prev => ({ ...prev, status_id: null }));
  }
  const validateForm = () => {
    let hasError = false;
    let newErrors = {};

    console.log("startDateTime", startDateTime)
    if (!selectedCollege) {
      newErrors.college = "College is required.";
      hasError = true;
    }
    if (!selectedCollegeEvent) {
      newErrors.college_event = "College Event is required."
      hasError = true;
    }

    if (!selectedAdmissionYear) {
      newErrors.admissionYear = "Admission Year is required.";
      hasError = true;
    }

    if (!selectedSemester) {
      newErrors.semester_id = "Semester is required.";
      hasError = true;
    }

    if (!selectedScheme) {
      newErrors.scheme_id = "Scheme is required.";
      hasError = true;
    }

    if (!startDateTime) {
      newErrors.startDateTime = "Start Date & Time is required.";
      hasError = true;
    }

    if (!endDateTime) {
      newErrors.endDateTime = "End Date & Time is required.";
      hasError = true;
    }

    if (!selectedStatus) {
      newErrors.status_id = "Status is required.";
      hasError = true;
    }

    setErrors(newErrors);
    return !hasError;
  };



  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const cancelForm = () => {
    navigate('/admin/collegeleveleventlist');
    //window.location.reload();
  };

  const navigatePage = () => {
    console.log("ok")
    navigate('/admin/collegeleveleventlist');
  };



  let cid = localStorage.getItem("collegeid");

  const handlefirstsubmit = () => {
    if (!validateForm()) {
      toast.error("Please fill mandatory fields");
      return;
    }
    setShowConfirmModal(true);

  };

  const handleSaveEventData = () => {

    // Actual submit begins
    const payloads = {
      pk_id: decodedID,
      college_id: selectedCollegeID,
      college_event_id: selectedCollegeEventId,
      admission_year: selectedAdmissionYearID,
      semester_id: selectedSemesterID,
      scheme_id: selectedSchemeID,
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      status: selectedStatusID,

    };
    console.log("payloads", payloads);
    http.post('/Admin/updateEventTimeExtension', payloads)
      .then((response) => {


        if (response.data.status_code === 'MSG2') {
          toast.success("Data updated successfully");
          setTimeout(() => {
            //navigate("/admin/collegeleveleventlist");
            setShowConfirmModal(false);
            //window.location.reload();

          }, 1000); // 2000ms = 2 seconds

        } else {
          toast.error("Failed to update data");
          setShowConfirmModal(false);

        }
      })
      .catch((error) => {

        setShowConfirmModal(false);

        const status = error.response?.status;
        const { status_code, message, errors } = error.response?.data || {};

        if (status === 401 && status_code === 'ERR9') {
          toast.error(message || "Invalid Token");
          setTimeout(() => navigate("/admin/"), 3000);
          return;
        }
        else if (status === 422 && status_code === 'ERR1') {
          toast.error(message || "Validation failed");
          console.log("Validation errors:", errors);
          return;
        }
        else if (status === 500 && status_code === 'ERR2') {
          toast.error(message || "Error while inserting");
          return;
        }
        else {
          toast.error("Something went wrong");
        }
      });

  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: 'left', // optional, for selected value
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  const admissionYearOptions = [
    { value: 2024, label: '2024' },
    { value: 2025, label: '2025' }
  ];
  const semesterOptions = [
    { value: 1, label: 'Semester 1' },
    { value: 2, label: 'Semester 2' },
    { value: 3, label: 'Semester 3' },
    { value: 4, label: 'Semester 4' },
    { value: 5, label: 'Semester 5' },
    { value: 6, label: 'Semester 6' },
    { value: 7, label: 'Semester 7' },
    { value: 8, label: 'Semester 8' }
  ];


  const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'closed', label: 'Closed' }
  ];

  const toDateTimeLocal = (dateTime) => {
    if (!dateTime) return '';

    // "2026-01-01 10:00:00" → "2026-01-01T10:00"
    return dateTime.replace(' ', 'T').slice(0, 16);
  };

  return (
    <>
      <ToastContainer />
      <Template>

        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>College Level Event Time Extension</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* <div className="table-responsive"> */}
                    <div className="col-md-12 txt-aln pdg14">
                      <div className="row">
                        <div className="col">




                          <div className="row">
                            <label className="col-md-5 txt-aln-lft">College<span className="errorclr">*</span></label>
                            <div className="col-md-7">
                              <Select
                                id="college_id"
                                name="college_id"
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                styles={customStyles}
                                className="form-control ht"
                                options={
                                  Array.isArray(allColleges) ?
                                    allColleges
                                      .map(college => ({
                                        value: college.college_id,
                                        label: college.college_name
                                      }))
                                    : []
                                }

                                value={selectedCollege}


                                onChange={handleCollegeChange}
                              />
                              {errors.college && <p className="text-danger">{errors.college}</p>}
                            </div>
                          </div>
                          <div className="row">
                            <label className="col-md-5 txt-aln-lft">College Event<span className="errorclr">*</span></label>
                            <div className="col-md-7">
                              <Select
                                id="event_id"
                                name="event_id"
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                styles={customStyles}
                                className="form-control ht"
                                // options={
                                //   Array.isArray(collegeEvents) ?
                                //     collegeEvents
                                //       .map(event => ({
                                //         value: event.id,
                                //         label: event.event_name
                                //       }))
                                //     : []
                                // }
                                options={collegeEventOptions}
                                value={selectedCollegeEvent}




                                onChange={handleCollegeEventChange}
                              />
                              {errors.college_event && <p className="text-danger">{errors.college_event}</p>}
                            </div>
                          </div>





                          <div className="row">
                            <label className="col-md-5 txt-aln-lft">Admission Year<span className="errorclr">*</span></label>
                            <div className="col-md-7">
                              <Select
                                id="admissionYear"
                                name="admissionYear"
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                styles={customStyles}
                                className="form-control ht"
                                options={admissionYearOptions}
                                value={selectedAdmissionYear}
                                onChange={handleAdmissionYearChange}
                              />
                              {errors.admissionYear && <p className="text-danger">{errors.admissionYear}</p>}
                            </div>
                          </div>

                          <div className="row">
                            <label className="col-md-5 txt-aln-lft">Semester<span className="errorclr">*</span></label>
                            <div className="col-md-7">
                              <Select
                                id="semester_id"
                                name="semester_id"
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                styles={customStyles}
                                className="form-control ht"
                                options={semesterOptions}
                                value={selectedSemester}
                                onChange={handleSemesterChange}
                              />

                              {errors.semester_id && <p className="text-danger">{errors.semester_id}</p>}
                            </div>
                          </div>
                          <div className="row">
                            <label className="col-md-5 txt-aln-lft">Scheme<span className="errorclr">*</span></label>
                            <div className="col-md-7">
                              <Select
                                id="scheme_id"
                                name="scheme_id"
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                styles={customStyles}
                                className="form-control ht"
                                options={schemeOptions}
                                value={selectedScheme}
                                onChange={handleShemeChange}
                              />
                              {errors.scheme_id && <p className="text-danger">{errors.scheme_id}</p>}
                            </div>
                          </div>

                          <div class="row mb-3">
                            <label class="col-md-5 txt-aln-lft">
                              Start Date & Time <span class="errorclr">*</span>
                            </label>
                            <div class="col-md-7">
                              <input
                                type="datetime-local"
                                id="startDateTime"
                                name="startDateTime"
                                class="form-control ht"
                                value={startDateTime}
                                onChange={(e) => setStartDateTime(e.target.value)}
                              />

                              {errors.startDateTime && <p className="text-danger">{errors.startDateTime}</p>}

                              {/* <Flatpickr
                                  className="form-control ht"
                                  value={startDateTime}
                                  options={{
                                    enableTime: true,
                                    dateFormat: "d/m/Y h:i K",
                                    time_24hr: false,
                                    minuteIncrement: 1,
                                    allowInput: true
                                  }}
                                  onChange={([date]) => {
                                    setStartDateTime(date);
                                  }}
                                /> */}
                            </div>
                          </div>

                          <div class="row mb-3">
                            <label class="col-md-5 txt-aln-lft">
                              End Date & Time <span class="errorclr">*</span>
                            </label>
                            <div class="col-md-7">
                              <input
                                type="datetime-local"
                                id="endDateTime"
                                name="endDateTime"
                                class="form-control ht"
                                value={endDateTime}
                                onChange={(e) => setEndDateTime(e.target.value)}
                              />

                              {errors.endDateTime && <p className="text-danger">{errors.endDateTime}</p>}

                            </div>
                          </div>
                          <div className="row">
                            <label className="col-md-5 txt-aln-lft">Status<span className="errorclr">*</span></label>
                            <div className="col-md-7">
                              <Select
                                id="status_id"
                                name="status_id"
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                styles={customStyles}
                                className="form-control ht"
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusChange}
                              />
                              {errors.status_id && <p className="text-danger">{errors.status_id}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                        <input className="btn btn-light" type="reset" style={{ border: '2px solid black' }} value="Cancel" onClick={cancelForm} />
                      </div>
                    </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>

            {showConfirmModal && (
              <div className="modal-backdrop show" style={{ opacity: 'unset' }}>
                <div className="modal d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirmation</h5>
                      </div>
                      <div className="modal-body">
                        <p>Do you want to update?
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => {

                          handleSaveEventData();
                        }}>
                          Save
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmModal(false)}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </Template>
    </>
  );
}
